export default __webpack_public_path__ + "static/media/sweet-shop-image.cbb9fe91.jpg";